module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown",
    class: {
      'dropdown--open': _vm.open, 'dropdown--no-shadow': _vm.noShadow, 'dropdown--clickable': !_vm.open && !_vm.disabled
    },
    on: {
      "click": _vm.stageClicked
    }
  }, [(!_vm.backBtn) ? _c('icon', {
    attrs: {
      "icon": _vm.icon
    }
  }) : _vm._e(), _vm._v(" "), (_vm.backBtn) ? _c('div', {
    staticClass: "dropdown__back-btn",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n      < " + _vm._s(_vm.$t('global.back')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dropdown__title"
  }, [_vm._v("\n        " + _vm._s(_vm.placeholder) + "\n    ")]), _vm._v(" "), (!_vm.open && !_vm.disabled) ? _c('div', {
    staticClass: "dropdown__edit-btn"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('global.edit')) + "\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2173c396","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dropDown.vue
// module id = 587
// module chunks = 0